import { render } from "./Fealty.vue?vue&type=template&id=6d398df0"
import script from "./Fealty.vue?vue&type=script&lang=js"
export * from "./Fealty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/kingdomIn/Fealty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d398df0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d398df0', __exports__)) {
    api.reload('6d398df0', __exports__)
  }
  
  module.hot.accept("./Fealty.vue?vue&type=template&id=6d398df0", () => {
    api.rerender('6d398df0', render)
  })

}


export default __exports__